import { useMutation, useQueryClient } from 'react-query';

import { deleteTechFromSite as remove } from 'api/clients/deleteTechFromSite';

interface Vars {
  objectSlug: string;
  techId: number;
}

const useDeleteTechFromSite = () => {
  const queryClient = useQueryClient();

  const {
    isSuccess,
    mutate: deleteTech,
    isLoading,
  } = useMutation(({ objectSlug, techId }: Vars) => remove(objectSlug, techId), {
    onSuccess: () => queryClient.invalidateQueries('tech'),
  });

  return { isSuccess, deleteTech, isLoading };
};

export default useDeleteTechFromSite;
